import Head from 'next/head';
import { Search } from 'components/template/search';

export default function SearchPage() {
  return (
    <>
      <Head>
        <title>Search | RTPCheck</title>
        {/* Internal search results: let crawlers follow links but keep these pages out of the index */}
        <meta name="robots" content="noindex, follow" />
      </Head>
      <Search />
    </>
  );
}
